import React from 'react';
import { connect } from 'react-redux';
import CohortLauncherDropdownMenu from '../components/CohortLauncherDropdownMenu';
import CohortLauncherReadOnlyMenu from '../components/CohortLauncherReadOnlyMenu';

const CohortLauncherMenu = ({
  allowCreate,
  allowRead,
  readOnly,
  code,
}) => (
  <>
    {readOnly
      ? <CohortLauncherReadOnlyMenu />
      : (
        <CohortLauncherDropdownMenu
          allowCreate={allowCreate}
          allowRead={allowRead}
          code={code}
        />
      )}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { cohorts: { create, read } } } },
  cohorts: { newCohortCode },
}) => ({
  allowCreate: create,
  allowRead: read,
  readOnly: read && !create,
  code: newCohortCode,
});

export default connect(mapStateToProps)(CohortLauncherMenu);
